import { stripDomain } from '@hotjar/webapp/utils/urls';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import type { TrackingArgs } from './types';
import { validateEventData } from './validate-event-data';
import * as hotjarTracking from './tools/hotjar';

interface ElementLoadingTime extends TrackingArgs {
  loadingTimeInSeconds: number;
}

/**
 * Track the time it took for an element to be visible on the page in seconds.
 */
export const elementLoadingTime = ({
  name,
  uiPosition,
  loadingTimeInSeconds,
  groupData,
  data = {},
}: ElementLoadingTime): Promise<void> => {
  const valid = validateEventData('Track.elementLoadingTime', [name, uiPosition, groupData]);

  if (valid) {
    const url = stripDomain(window.location.href);
    const trackData = {
      element_name: name,
      ui_position: uiPosition,
      url_event_was_triggered_on: url, // we add the url_event_was_triggered_on as current page url in case it is not defined in the groupData
      loading_time_in_seconds: loadingTimeInSeconds,
      ...data,
      ...groupData,
    };

    hotjarTracking.tagRecording(`Element loaded in: ${loadingTimeInSeconds}s`);
    return Segment.track('Element Loading Time', trackData);
  }

  return Promise.resolve();
};
